/**
 * useMobile.js — Shared hook for mobile breakpoint detection
 *
 * Returns { isMobile } — true when viewport < 900px (MUI md breakpoint).
 * Supports ?forceMobile=1 URL param for desktop testing.
 */

import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export function useMobile() {
  const theme = useTheme();
  const isNarrow = useMediaQuery(theme.breakpoints.down('md'));

  // Debug override: ?forceMobile=1 in URL
  const forced =
    typeof window !== 'undefined' &&
    new URLSearchParams(window.location.search).get('forceMobile') === '1';

  return { isMobile: isNarrow || forced };
}
